var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-section-heading"},[_c('h1',{staticClass:"main-section-header"},[_vm._v(" "+_vm._s(_vm.Title)+" "),_c('span',{staticClass:"subheading",attrs:{"v-if":_vm.Subtitle}},[_vm._v(_vm._s(_vm.Subtitle))])]),_c('h6',{staticClass:"main-section-header"}),_c('div',{staticClass:"title-section-settings"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }